import { useEffect, useState } from "react";
import { Card, Icon, Table, TableRow, TableBody, TableCell, Divider } from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import AppConfig from "appConfig";

function DataFormSubmissionCard({ captureRef, data }) {
  function getMediaElement(vrf, v) {
    if (v.startsWith("data:image")) {
      return (
        <MDBox
          onClick={async () => {
            const response = await fetch(v);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank");
            URL.revokeObjectURL(blobUrl);
          }}
        >
          <img src={v} alt="" width={120} />
        </MDBox>
      );
    }

    if (v.startsWith("data:audio")) {
      return (
        <audio src={v} controls>
          <track default kind="captions" srcLang="en" />
        </audio>
      );
    }

    if (v.startsWith("data:video")) {
      return (
        <video src={v} height={150} controls>
          <track default kind="captions" srcLang="en" />
        </video>
      );
    }

    // Link it externally
    if (v.startsWith("data:")) {
      return (
        <MDBox>
          <a href={`${AppConfig.api_base_url}dff/dl/${vrf}`} target="_blank" rel="noreferrer">
            PREVIEW
          </a>
        </MDBox>
      );
    }

    return (
      <MDBox style={{ wordBreak: "break-word" }}>
        <MDTypography variant="text" fontWeight="light" fontSize={15}>
          {v}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <MDBox>
      <Card>
        <MDBox>
          <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              Captured Information
            </MDTypography>
            <MDButton
              variant="outlined"
              color="dark"
              iconOnly
              onClick={() => {
                window.open(
                  `${AppConfig.api_base_url}portal/data_captures/${captureRef}/excel.json`,
                  "_blank"
                );
              }}
            >
              <Icon>file_download</Icon>
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
      <MDBox mt={3}>
        {Object.entries(data).map(([i, section]) => (
          <MDBox mb={3}>
            <Card>
              <MDBox id={`ref_${i}`} mb={2}>
                <MDBox ml={2} mt={2}>
                  <MDTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                    {section.name}
                  </MDTypography>
                  <Divider />
                </MDBox>
                <Table>
                  <TableBody>
                    {section.items.map((item) => (
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            {item.name}
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDBox>
                            {typeof item.value === "object" ? (
                              <MDBox>
                                {Array.isArray(item.value) ? (
                                  <MDBox>
                                    {item.value.map((objRow) =>
                                      Object.entries(objRow).map(([x, y]) => (
                                        <>
                                          <MDTypography
                                            variant="text"
                                            fontWeight="regular"
                                            fontSize={15}
                                          >
                                            {x}
                                          </MDTypography>
                                          <MDTypography
                                            fontSize={15}
                                            variant="text"
                                            fontWeight="light"
                                          >
                                            {y}
                                          </MDTypography>
                                        </>
                                      ))
                                    )}
                                  </MDBox>
                                ) : (
                                  <div>
                                    {Object.entries(item.value).map(([x, y]) => (
                                      <div>
                                        <MDTypography
                                          variant="text"
                                          fontWeight="regular"
                                          fontSize={15}
                                        >
                                          {x}
                                        </MDTypography>
                                        <MDTypography
                                          fontSize={15}
                                          variant="text"
                                          fontWeight="light"
                                        >
                                          {y}
                                        </MDTypography>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </MDBox>
                            ) : (
                              <div>
                                {typeof item.value === "string" ? (
                                  getMediaElement(item.reference, item.value)
                                ) : (
                                  <MDTypography
                                    variant="text"
                                    fontWeight="light"
                                    fontSize={15}
                                    style={{ wordWrap: "break-word" }}
                                  >
                                    {item.value}
                                  </MDTypography>
                                )}
                              </div>
                            )}
                          </MDBox>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </MDBox>
            </Card>
          </MDBox>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default DataFormSubmissionCard;
